import React from 'react'
import PropTypes from 'prop-types'
import { useNavigate } from 'react-router-dom'

import AddNewDefault from '../Graphics/AddNew'
import BinDefault from '../Graphics/Bin'
import ColdAirDrainDefault from '../Graphics/ColdAirDrain'
import FlowDefault from '../Graphics/Flow'
import LevelDefault from '../Graphics/Level'
import MoistureDefault from '../Graphics/Moisture'
import PowerDefault from '../Graphics/Power'
import PumpDefault from '../Graphics/Pump'
import PumpFrostWaterDefault from '../Graphics/PumpFrostWater'
import RedX from '../Graphics/RedX'
import SelectionCheckIcon from '../Graphics/SelectionCheckIcon'
import SpeedometerDefault from '../Graphics/Speedometer'
import ThermometerDefault from '../Graphics/Thermometer'
import TractorDefault from '../Graphics/Tractor'
import WeatherDefault from '../Graphics/Weather'
import ValveDefault from '../Graphics/Valve'
import WindMachineDefault from '../Graphics/WindMachine'

import styles from '../../../../css/compacts.module.css'

const notFound = () => (
  <i
    className='fa fa-times-circle'
    style={{
      color: 'red',
      fontSize: '3em',
      fontWeight: 'bold',
    }}
  />
)

const AppButton = function AppButton ({
  checked = false,
  disabled = false,
  icon,
  label,
  link = undefined,
  onClick = undefined,
  style = undefined,
}) {
  const navigate = useNavigate()

  const icons = {
    AddNew: <AddNewDefault style={style} />,
    Bin: <BinDefault style={style} />,
    Configure: <AddNewDefault style={style} />,
    Flow: <FlowDefault style={style} />,
    ColdAirDrain: <ColdAirDrainDefault style={style} />,
    Level: <LevelDefault style={style} />,
    Moisture: <MoistureDefault style={style} />,
    MoistureSensor: <MoistureDefault style={style} />,
    Power: <PowerDefault style={style} />,
    Pump: <PumpDefault style={style} />,
    PumpFrostWater: <PumpFrostWaterDefault style={style} />,
    RedX: <RedX style={style} />,
    Speedometer: <SpeedometerDefault style={style} />,
    Thermometer: <ThermometerDefault style={style} />,
    Tractor: <TractorDefault style={style} />,
    Valve: <ValveDefault style={style} />,
    Weather: <WeatherDefault style={style} />,
    WindMachine: <WindMachineDefault style={style} />,
  }

  // Safely get the icon element
  const getIconElement = () => {
    if (icon && typeof icon === 'string' && icons[icon]) {
      return icons[icon]
    }
    return notFound()
  }

  let iconElement

  if (checked) {
    iconElement = (
      <svg>
        {getIconElement()}
        <g transform='translate(0,0)'>
          <SelectionCheckIcon />
        </g>
      </svg>
    )
  } else {
    iconElement = getIconElement()
  }

  // Handle the button click - either use onClick or redirect with link
  const handleButtonClick = (e) => {
    if (onClick) {
      onClick(e)
    } else if (link) {
      // CRITICAL FIX: Use direct window.location with absolute path
      // This ensures we always navigate to the complete path including /app prefix

      // Make sure we're using an absolute path (starting with /)
      const absolutePath = link.startsWith('/') ? link : `/${link}`

      // Set the location to the full URL
      navigate(`${absolutePath}`)
    }
  }

  // Create a single button element that handles all our cases
  return (
    <button
      className={styles.appButton}
      disabled={disabled}
      onClick={handleButtonClick}
      style={style}
      type='button'
    >
      <div className={styles.appIcon}>
        {iconElement}
        <h6>{label}</h6>
      </div>
    </button>
  )
}


AppButton.propTypes = {
  checked: PropTypes.bool,
  disabled: PropTypes.bool,
  icon: PropTypes.any.isRequired,
  label: PropTypes.string.isRequired,
  link: PropTypes.string,
  onClick: PropTypes.func,
  style: PropTypes.object,
}

export default AppButton
